































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { downloadfile, downloadpdf, downloadZip, downloadJieTiZip } from '@/api/declare'
import { gettpoiclist, getExpertNum, getRandomList, addExperts, getExpertsList, getExpertReview, getAddExList, uploadSource, getFileList, deleteUploadFile, updataStatus } from '@/api/tissuemanage'
import Pagination from '@/components/Pagination/index.vue'
import moment from 'moment'
@Component({
  name: 'guideManage',
  components: { Pagination }
})
export default class extends Vue {
  [x: string]: any;
  // [x: string]: any;
  mounted() {
    this.getList(this.listQuery)
    this.getYearList()
    this.baseurl = (window as any).downloadurl
    this.listQuery.userid = window.sessionStorage.getItem('id')
    this.listQuery.role = Number(window.sessionStorage.getItem('role'))
  }
  private currtentpage = 1;
  private total: number = 0;
  private topicrole = '';
  private shstate = '';
  private selectVal = ''
  // 打印凭证的参数
  private printObj = {
    id: 'maincard', // 打印标签的id
    popTitle: 'Document', // 文件标题
    extraCss: 'https://www.google.com,https://www.google.com',
    extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
  }
  private expertQuery:any = {
    pageNum: 1,
    pageSize: 10,
    param: '',
    randomNum: 0,
    topicIds: []
  }
  // 上传文件的接口
  private fileObj = {

  }
  // 综合评审请求参数
  private expertcomQuery:any = {
    pageNum: 1,
    pageSize: 10,
    param: '',
    numBer: '',
    randomNum: 0,
    topicIds: []
  }
  private formObj:any = {
    title: '',
    expertVis: false,
    number: '', // 选中的人数
    addExoertVis: false, // 添加评审专家模态框
    searcVal: '', // 添加评审专家查询名称
    expertList: [], // 线上专家数组
    tableData: [], // 添加评审专家数据源
    total: 0,
    currentPage: 1,
    multipleExperts: [], // 添加专家页面复选多个数据
    multipleComExperts: [], // 添加综合专家页面复选多个数据
    comExpertVis: false, // 指定综合评审专家
    addcomExoertVis: false, // 指定专家评审页面
    comTableData: [],
    comExpertList: [], // 线下专家数组
    topicId: '', // 课题id
    radioVal: '',
    leaderIndex: 0,
    comCurrentPage: 1,
    comTotal: 0
  };
  private zjhzForm:any = {
    visible: false,
    maxNum: 0,
    minNum: 0,
    average: 0,
    name: '',
    topicUser: '',
    level: '', // 课题级别
    infoList: []
  }
  // 上传凭证相关参数
  private uploadForm:any = {
    visible: false,
    tableData: [],
    diaFile: false,
    fileList: [],
    topicId: '',
    selectVal: ''
  }
  // 查看已上传的凭证
  private uploadsFile:any = {
    visible: false,
    tableData: [],
    diaFile: false,
    fileList: [],
    topicId: '',
    selectVal: ''
  }
  // 课题综合评审驳回参数
  private refuseopic:any = {
    visible: false,
    value: ''
  }
  // 选择人数下拉框
  private options = [
    {
      value: '1',
      label: '1'
    },
    {
      value: '2',
      label: '2'
    },
    {
      value: '3',
      label: '3'
    },
    {
      value: '4',
      label: '4'
    },
    {
      value: '5',
      label: '5'
    }
  ]
  private usestate = [
    {
      value: 1,
      label: '启用'
    },
    {
      value: 0,
      label: '禁用'
    }
  ];
  private roleoptions = [
    {
      label: '中心选题',
      value: 0
    },
    {
      label: '自主选题',
      value: 1
    }
  ];
  private stateoptions = [
    {
      label: '待审核',
      value: 0
    },
    {
      label: '终审通过',
      value: 1
    },
    {
      label: '已撤回',
      value: 2
    },
    {
      label: '未提交',
      value: 3
    },
    {
      label: '预算驳回',
      value: 4
    },
    {
      label: '驳回',
      value: 5
    },
    {
      label: '形审通过',
      value: 6
    },
    {
      label: '形审未通过',
      value: 7
    },
    {
      label: '专家评审中',
      value: 8
    },
    {
      label: '专家评审完成',
      value: 9
    },
    {
      label: '综合评审中',
      value: 10
    },
    {
      label: '综合评审未通过',
      value: 11
    },
    {
      label: '综合评审通过',
      value: 12
    },
    {
      label: '阶段汇报',
      value: 13
    },//copy14 andy
    {
      label: '结题汇报',
      value: 14
    }
  ];
  private tableData = [];
  private name = '';
  private isloading = true;
  private listQuery:any = {
    level: -1,
    limit: 10,
    name: '',
    num: '',
    page: 1,
    state: -1,
    topictype: -1,
    userid: '',
    role: 0,
    expertRole: '',
    year: null
  };
  //andy 增加查询条件
  private declarername = null //申报人姓名
  private subjectnumber = null //课题编号
  private year = null //年度
  private yearlist : any[] = [] //年份list
  private uploadRules = {
    selectVal: [
      { required: true, message: '请选择综合审批状态', trigger: 'change' },
    ]
  }
  private refuseRule = {
    value: [
      { required: true, message: '请输入审批不通过原因', trigger: 'blur' },
    ]
  }
  // 获取列表
  private async getList(params: any) {
    await gettpoiclist(params)
      .then((res) => {
        if (res.code === 200) {
          this.tableData = res.data.itemBeanList[0]
          this.total = res.data.total
          this.isloading = false
        }
      })
      .catch(() => {
        // this.list = [];
        // this.listLoading = false;
      })
  }
  private cleardata() {
    this.listQuery.state = -1
    this.getList(this.listQuery)
  }
  private changestate(val) {
    if (val == null) {
      this.listQuery.state = -1
    } else {
      this.listQuery.state = val
    }
    this.getList(this.listQuery)
  }
  //andy 增加年度查询条件
  private clearyear() {
    this.listQuery.year = null
    this.getList(this.listQuery)
  }
  private changeyear(val) {
    if (val != null) {
      this.listQuery.year = val
    }
    this.getList(this.listQuery)
  }
  private prints() {
    let prints:any = document.getElementById('maincard')
    prints.title = '课题专家评审汇总内容'
  }
  private changerole(val) {
    console.log(val === '')
    if (val === '') {
      this.listQuery.topictype = -1
    } else {
      this.listQuery.topictype = val
    }
    console.log(this.listQuery.topictype)
    this.getList(this.listQuery)
  }
  private onSubmit() {
    this.listQuery.page = 1
    this.listQuery.name = this.name
    this.getList(this.listQuery)
  }
  private clearSearch() {
    this.listQuery = {
      level: -1,
      limit: 10,
      name: '',
      num: '',
      page: 1,
      state: -1,
      topictype: -1,
      userid: '',
      role: 0,
      expertRole: ''
    }
    this.name = ''
    this.topicrole = ''
    this.shstate = ''
    this.year = null
    this.getList(this.listQuery)
  }
  // 查询线上线下专家
  searchUserList() {
    getAddExList(this.expertQuery).then((res) => {
      if (res.code === 200) {
        this.formObj.tableData = res.data.list.records
        this.formObj.total = res.data.total
      }
    })
  }
  private watchitem(params, row) {
    let topicinfo: any = JSON.stringify(row)
    window.sessionStorage.setItem('topicid', JSON.stringify(params))
    window.sessionStorage.setItem('iswatch', 'true')
    window.sessionStorage.setItem('ishandle', 'true')
    window.sessionStorage.setItem('topicinfo', topicinfo)
    let time = row.createtime.substring(0, 4)
    window.sessionStorage.setItem('time', time)
    if (row.isrefuse == 1) {
      window.sessionStorage.setItem('isrefuse', 'true')
    } else {
      window.sessionStorage.removeItem('isrefuse')
    }
    this.$router.push({ path: '/declare/declare' })
  }
  private giveProject(params: any, row: any) {
    let topicinfo: any = JSON.stringify(row)
    window.sessionStorage.setItem('topicid', JSON.stringify(params))
    window.sessionStorage.setItem('iswatch', 'true')
    window.sessionStorage.setItem('topicinfo', topicinfo)
    window.sessionStorage.removeItem('ishandle')
    let time = row.createtime.substring(0, 4)
    window.sessionStorage.setItem('time', time)
    debugger
    // isrefuse=1的时候是预算驳回后重新上传的状态 declare页面显示预算驳回后的表格
    if (row.isrefuse == 1) {
      window.sessionStorage.setItem('isrefuse', 'true')
    } else {
      window.sessionStorage.removeItem('isrefuse')
    }
    this.$router.push({ path: '/delcareProject/delcareProject' })
  }
  private async editItem(params: any, row: any) {
    let topicinfo: any = JSON.stringify(row)
    window.sessionStorage.setItem('topicid', JSON.stringify(params))
    window.sessionStorage.setItem('iswatch', 'true')
    window.sessionStorage.setItem('topicinfo', topicinfo)
    window.sessionStorage.removeItem('ishandle')
    let time = row.createtime.substring(0, 4)
    window.sessionStorage.setItem('time', time)
    // isrefuse=1的时候是预算驳回后重新上传的状态 declare页面显示预算驳回后的表格
    if (row.isrefuse == 1) {
      window.sessionStorage.setItem('isrefuse', 'true')
    } else {
      window.sessionStorage.removeItem('isrefuse')
    }
    this.$router.push({ path: '/declare/declare' })
  }
  downfile(type_, row) {
    let param = {
      id: row.id
    };
    let sbdata: any = {} // 申报对象集合
    let ysdaya: any = {} // 预算对象集合
    let jddata = {
      filepath: '',
      filename: ''
    } //阶段对象集合
    if(type_ !== 3 && type_ !== 4){
      downloadpdf(param).then((res) => {
      if (res.code === 200) {
        // state 0未生成 1生成中 2已生成
        let data_ = res.data
        data_.forEach((res) => {
          // res.type=0 完整版pdf  =1预算pdf
          if (res.type === 0) {
            sbdata = res
          } else {
            ysdaya = res
          }
        })
        if (type_ === 0) {
          if (sbdata.state === 0) {
            this.$message.warning('申报表暂未生成，请先生成后下载')
          } else if (sbdata.state === 1) {
            this.$message.warning('申报表正在生成中,请稍后下载')
          } else {
            var x = new XMLHttpRequest()
            // sbdata.url字符串前面的是完整版申报pdf 后面的是论证活页的pdf
            let href = this.baseurl + '/pdf/' + sbdata.url.split(',').shift()
            x.open('GET', href, true)
            x.responseType = 'blob'
            x.onload = function(e) {
              var url = window.URL.createObjectURL(x.response)
              var a = document.createElement('a')
              a.href = url
              if (row.name == null) {
                a.download = '申报表'
              } else {
                a.download =
                  '申请书_' +
                  row.name +
                  '_' +
                  moment(new Date()).format('YYYY-MM-DD HH-MM-ss')
              }
              a.click()
            }
            x.send()
          }
        } else if (type_ === 1) {
          if (ysdaya.state === 0) {
            this.$message.warning('预算表暂未生成，请先生成后下载')
          } else if (ysdaya.state === 1) {
            this.$message.warning('预算表正在生成中,请稍后下载')
          } else {
            let href = this.baseurl + '/pdf/' + ysdaya.url
            var x = new XMLHttpRequest()
            x.open('GET', href, true)
            x.responseType = 'blob'
            x.onload = function(e) {
              var url = window.URL.createObjectURL(x.response)
              var a = document.createElement('a')
              a.href = url
              if (row.name == null) {
                a.download = '预算表'
              } else {
                a.download = row.name + '预算表'
              }
              a.click()
            }
            x.send()
          }
        } else {
          if (sbdata.state === 0) {
            this.$message.warning('论证活页暂未生成，请先生成后下载')
          } else if (sbdata.state === 1) {
            this.$message.warning('论证活页正在生成中,请稍后下载')
          } else {
            let href = this.baseurl + '/pdf/' + sbdata.url.split(',').pop()
            console.log('href', href)
            var x = new XMLHttpRequest()
            x.open('GET', href, true)
            x.responseType = 'blob'
            x.onload = function (e) {
              var url = window.URL.createObjectURL(x.response)
              var a = document.createElement('a')
              a.href = url
              if (row.name == null) {
                a.download = '论证活页'
              } else {
                a.download =
                  '论证活页_' +
                  row.name +
                  '_' +
                  moment(new Date()).format('YYYY-MM-DD HH-MM-ss')
              }
              a.click()
            }
            x.send()
          }
        }
      }
    })
    //copy 14 andy
    } else if (type_ === 4) {
      downloadJieTiZip(param).then((res) => {
        if (res.code === 200) {
          // state 0未生成 1生成中 2已生成
          jddata = res.data
          if(jddata !== null){
            if (type_ === 4) {
              let href = this.baseurl + '/pdf/' + jddata.filepath.split(',').pop()
              console.log('href', href)
              debugger
              var x = new XMLHttpRequest()
              x.open('GET', href, true)
              x.responseType = 'blob'
              x.onload = function (e) {
                var url = window.URL.createObjectURL(x.response)
                var a = document.createElement('a')
                a.href = url
                a.download = jddata.filename
                a.click()
              }
              x.send()
              // let href = '/pdf/' + jddata.filepath

              // const savea = document.createElement('a')
              // savea.download = jddata.filename
              // savea.href = href
              // savea.click()
            }
          }else{
            this.$message.warning('未上传结题汇报内容,请稍后下载')
          }
        }
      })
    } else {
      downloadZip(param).then((res) => {
        debugger
        if (res.code === 200) {
          // state 0未生成 1生成中 2已生成
          jddata = res.data
          if(jddata !== null){
            if (type_ === 3) {
              let href = this.baseurl + '/pdf/' + jddata.filepath.split(',').pop()
              console.log('href', href)
              debugger
              var x = new XMLHttpRequest()
              x.open('GET', href, true)
              x.responseType = 'blob'
              x.onload = function (e) {
                var url = window.URL.createObjectURL(x.response)
                var a = document.createElement('a')
                a.href = url
                a.download = jddata.filename
                a.click()
              }
              x.send()
              // let href = '/pdf/' + jddata.filepath

              // const savea = document.createElement('a')
              // savea.download = jddata.filename
              // savea.href = href
              // savea.click()
            }
          }else{
            this.$message.warning('未上传阶段汇报内容,请稍后下载')
          }
        }
        
      })
    }
  }

  watchfile(type_, row) {
    let param = {
      id: row.id
    };
    let sbdata: any = {} // 申报对象集合
    let ysdaya: any = {} // 预算对象集合
    downloadpdf(param).then((res) => {
      if (res.code === 200) {
        // state 0未生成 1生成中 2已生成
        let data_ = res.data
        data_.forEach((res) => {
          // res.type=0 完整版pdf  =1预算pdf
          if (res.type === 0) {
            sbdata = res
          } else {
            ysdaya = res
          }
        })
        if (type_ === 0) {
          if (sbdata.state === 0) {
            this.$message.warning('申报表暂未生成，请先生成后下载')
          } else if (sbdata.state === 1) {
            this.$message.warning('申报表正在生成中,请稍后下载')
          } else {
            var x = new XMLHttpRequest()
            let href = this.baseurl + 'pdf/' + sbdata.url
            x.open('GET', href, true)
            x.responseType = 'blob'
            x.onload = function(e) {
              var url = window.URL.createObjectURL(x.response)
              var a = document.createElement('a')
              a.href = url
              a.target = '_blank'
              // if (row.name == null) {
              //   a.download = "申报表";
              // } else {
              //   a.download = row.name + "申报表";
              // }
              a.click()
            }
            x.send()
          }
        } else {
          if (ysdaya.state === 0) {
            this.$message.warning('预算表暂未生成，请先生成后下载')
          } else if (ysdaya.state === 1) {
            this.$message.warning('预算表正在生成中,请稍后下载')
          } else {
            let href = this.baseurl + '/pdf/' + ysdaya.url
            let url = window.URL.createObjectURL(href)
            const savea = document.createElement('a')
            savea.download = 'sss'
            if (row.name == null) {
              savea.download = '预算表'
            } else {
              savea.download = row.name + '预算表'
            }
            savea.href = url
            savea.click()
          }
        }
      }
    })
  }
  private handleClose() {
    this.formObj.expertVis = false
  }

  // 分页
  private handleSizeChange(val: number) {
    this.listQuery.limit = val
    this.getList(this.listQuery)
  }
  private handleCurrentChange(val: number) {
    this.listQuery.page = val
    this.getList(this.listQuery)
  }
  private expertSizeChange(val) {
    this.expertQuery.pageSize = val
    this.getExpertList(this.expertQuery)
  }
  private expertCurrentChange(val) {
    this.expertQuery.pageNum = val
    this.getExpertList(this.expertQuery)
  }
  private expertcomSize(val) {
    this.expertcomQuery.pageSize = val
  }
  private expertcomPage(val) {
    this.expertcomQuery.pageNum = val
  }
  // 指定专家单选组长
  private getCurrentRow(val) {
    this.formObj.leaderIndex = val
    this.formObj.comExpertList.forEach((res) => {
      res.isgroupleader = false
    })
    this.formObj.comExpertList[val].isgroupleader = true
  }
  private cellStyle({
    row,
    column,
    rowIndex,
    columnIndex
  }: {
    row: any;
    column: any;
    rowIndex: any;
    columnIndex: any;
  }) {
    return 'text-align:center'
  }

  private rowClass({ row, rowIndex }: { row: any; rowIndex: any }) {
    return 'text-align:center'
  }
  // 指定专家模态框
  private giveExperst(val) {
    this.formObj.expertVis = true
    this.selectVal = ''
    this.formObj.title = '指定评审专家'
    this.formObj.topicId = val.id
    this.expertcomQuery.topicIds = []
    this.expertcomQuery.topicIds.push(val.id)
    let param:any = {
      type: 1, // 1线上专家 2线下专家
      topicIds: this.formObj.topicId
    }
    getExpertsList(param).then((res) => {
      this.formObj.expertList = res.data
    })
  }
  // 指定线下专家
  private giveLeader(val) {
    this.formObj.comExpertVis = true
    this.formObj.title = '指定综合评审专家'
    this.expertcomQuery.numBer = ''
    this.formObj.topicId = val.id
    this.expertcomQuery.topicIds.push(val.id)
    let param:any = {
      type: 2, // 1线上专家 2线下专家
      topicIds: this.formObj.topicId
    }
    getExpertsList(param).then((res) => {
      this.formObj.comExpertList = res.data
      this.formObj.radioVal = true
    })
  }
  // 随机抽取线上专家人数
  choosePerson() {
    let param:any = {
      pageNum: 1,
      pageSize: 10,
      param: '',
      topicIds: []
    }
    param.randomNum = Number(this.selectVal)
    param.topicIds.push(this.formObj.topicId)
    getRandomList(param).then((res) => {
      if (res.code === 200) {
        this.formObj.expertList = this.formObj.expertList.concat(res.data)
        let newObj = {}
        this.formObj.expertList = this.formObj.expertList.reduce((cur, next) => {
          newObj[next.id] ? '' : newObj[next.id] = true && cur.push(next)
          return cur
        }, [])
      } else if (res.code === 417) {
        this.$message.warning(res.message)
      }
    })
  }
  chooseComPerson() {
    let param:any = {
      pageNum: 1,
      pageSize: 10,
      param: '',
      topicIds: []
    }
    param.randomNum = Number(this.expertcomQuery.numBer)
    param.topicIds.push(this.formObj.topicId)
    getRandomList(param).then((res) => {
      if (res.code === 200) {
        this.formObj.comExpertList = this.formObj.comExpertList.concat(res.data)
        let newObj = {}
        this.formObj.comExpertList = this.formObj.comExpertList.reduce((cur, next) => {
          newObj[next.id] ? '' : newObj[next.id] = true && cur.push(next)
          return cur
        }, [])
      } else if (res.code === 417) {
        this.$message.warning(res.message)
      }
    })
  }
  // 添加评审专家
  addPerson() {
    this.formObj.addExoertVis = true
    this.formObj.title = '添加评审专家'
    this.expertQuery.param = ''
    this.expertQuery.topicIds.push(this.formObj.topicId)
    getAddExList(this.expertQuery)
      .then((res) => {
        if (res.code === 200) {
          this.formObj.tableData = res.data.list.records
          this.formObj.total = res.data.total
        }
      })
  }
  // 从指定综合评审专家进入的添加评审专家
  addcomPerson() {
    this.formObj.addcomExoertVis = true
    this.formObj.title = '添加指定综合评审专家'
    this.expertcomQuery.param = ''
    this.expertcomQuery.topicIds.push(this.formObj.topicId)
    getAddExList(this.expertcomQuery)
      .then((res) => {
        if (res.code === 200) {
          this.formObj.comTableData = res.data.list.records
          this.formObj.comTotal = res.data.total
        }
      })
  }
  // 提交线下专家
  submitComExperts() {
    let param:any = []
    let obj:any = {
      expertIds: [],
      topicId: this.formObj.topicId,
      type: 2
    }
    this.formObj.comExpertList.forEach((res) => {
      let expertObj:any = {}
      expertObj.expertId = res.id
      expertObj.isgroupleader = false
      obj.expertIds.push(expertObj)
    })
    obj.expertIds[this.formObj.leaderIndex].isgroupleader = true
    param.push(obj)
    addExperts(param).then((res) => {
      if (res.code === 200) {
        this.$message.success('课题绑定综合评审专家成功')
        this.formObj.expertVis = false
        this.formObj.comExpertVis = false
        this.formObj.addcomExoertVis = false
        this.getList(this.listQuery)
      } else if (res.code === 417) {
        this.$message.warning(res.data)
      }
    })
  }
  addChooseExperts() {
    this.formObj.addExoertVis = false
    this.formObj.expertList = this.formObj.expertList.concat(this.formObj.multipleExperts)
    console.log('xxx', this.formObj.expertList)
    let newObj = {}
    this.formObj.expertList = this.formObj.expertList.reduce((cur, next) => {
      newObj[next.id] ? '' : newObj[next.id] = true && cur.push(next)
      return cur
    }, [])
  }
  // 指定线上专家
  submitExperts() {
    let param:any = []
    let obj:any = {
      expertIds: [],
      topicId: this.formObj.topicId,
      type: 1
    }
    this.formObj.expertList.forEach((res) => {
      let expertObj:any = {}
      expertObj.expertId = res.id
      expertObj.isgroupleader = false
      obj.expertIds.push(expertObj)
    })
    param.push(obj)
    addExperts(param).then((res) => {
      if (res.code === 200) {
        this.$message.success('课题绑定综合评审专家成功')
        this.formObj.expertVis = false
        this.formObj.addcomExoertVis = false
        this.formObj.addcomExoertVis = false
        this.getList(this.listQuery)
      } else {
        this.$message.warning(res.message)
      }
    })
  }
  // 提交选择专家
  submitchooseExperts() {
    this.formObj.comExpertList = this.formObj.comExpertList.concat(this.formObj.multipleComExperts)
    let newObj = {}
    this.formObj.comExpertList = this.formObj.comExpertList.reduce((cur, next) => {
      newObj[next.id] ? '' : newObj[next.id] = true && cur.push(next)
      return cur
    }, [])
    this.formObj.addcomExoertVis = false
    this.formObj.title = '指定综合评审专家'
  }
  // 综合审批通过
  agreeTopic() {
    let param = {
      dismiss: '',
      id: this.uploadForm.topicId,
      state: 12
    }
    updataStatus(param).then((res) => {
      if (res.code === 200) {
        this.uploadForm.visible = false
        this.getList(this.listQuery)
      }
    })
  }
  // 提交内容
  submitRefuse() {
    (this.$refs.refuseRule as any).validate((valid) => {
      if (valid) {
        let param = {
          dismiss: this.refuseopic.value,
          id: this.uploadForm.topicId,
          state: 11
        }
        updataStatus(param).then((res) => {
          if (res.code === 200) {
            this.uploadForm.visible = false
            this.refuseopic.visible = false
            this.$message.success('课题综合评审评审未通过')
          }
        })
      }
    })
  }
  // 综合审批通过
  refuseTopic() {
    this.refuseopic.visible = true

  }
  expertSize(val) {
    this.expertQuery.limit = val
    this.addPerson()
  }
  expertPage(val) {
    this.expertQuery.page = val
    this.addPerson()
  }
  // 添加专家复选框
  handleSelectionChange(val) {
    this.formObj.multipleExperts = val
  }
  handleSelectionComChange(val) {
    this.formObj.multipleComExperts = val
  }
  closeExperts() {
    this.formObj.addExoertVis = false
    this.formObj.addcomExoertVis = false
  }
  // 关闭指定线下专家模态框
  closeComExpert() {
    this.formObj.comExpertVis = false
    this.zjhzForm.visible = false
  }
  // 删除指定专家
  removeChoose(index) {
    this.formObj.expertList.splice(index, 1)
    this.searcVal = String(this.formObj.expertList.length)
  }
  removeChooseCom(index) {
    this.formObj.comExpertList.splice(index, 1)
    this.expertcomQuery.numBer = String(this.formObj.expertList.length)
  }
  // 查询专家评审汇总
  getExpertScore(val) {
    this.zjhzForm.visible = true
    this.zjhzForm.infoList = []
    let param = {
      topicId: val.id
    }
    getExpertReview(param).then((res) => {
      if (res.code === 200) {
        this.zjhzForm.maxNum = res.data.maxScore
        this.zjhzForm.minNum = res.data.minScore
        this.zjhzForm.average = res.data.average
        this.zjhzForm.name = val.name
        this.zjhzForm.topicUser = val.headname
        res.data.infoList.forEach((res:any) => {
          if (res.score !== null && res.idea !== null) {
            this.zjhzForm.infoList.push(res)
          }
        })
      }
    })
  }
  claseZjhz() {
    this.uploadForm.visible = false
  }
  closebhZjhz() {
    this.refuseopic.visible = false
  }
  // 上传文件
  uploadPzfile(val) {
    this.uploadForm.visible = true
    this.uploadForm.topicId = val
    this.getFileList()
  }
  watchUploadFile(val) {
    this.uploadsFile.visible = true
    this.uploadsFile.topicId = val
    let param = {
      id: val
    }
    getFileList(param).then((res) => {
      if (res.code === 200) {
        this.uploadsFile.tableData = res.data
      }
    })
  }
  //
  claseHandleFile() {
    this.uploadsFile.visible = false
  }
  // 查询专家上传的课题文件
  getFileList() {
    let param = {
      id: this.uploadForm.topicId
    }
    getFileList(param).then((res) => {
      if (res.code === 200) {
        this.formObj.tableData = res.data
      }
    })
  }
  // 上传文件文件列显示icon图标
  renderHeader(h, { column }) { // h即为cerateElement的简写，具体可看vue官方文档
    return h(
      'div',
      [
        h('span', column.label),
        h('i', {
          class: 'el-icon-folder',
          style: 'margin-left:5px;font-size:15px'
        })
      ]
    )
  }
  // 按名称查询专家
  chooseExpert() {
    getAddExList(this.expertcomQuery)
      .then((res) => {
        if (res.code === 200) {
          this.formObj.comTableData = res.data.list.records
          this.formObj.comTotal = res.data.total
        }
      })
  }
  // 打开上传文件的页面
  openFileDia() {
    this.uploadForm.diaFile = true
    this.uploadForm.fileList = []
  }
  // 上传文件接口
  handleCloseFile() {
    this.uploadForm.diaFile = false
  }
  fileBeforeRemove(file: any, fileList: any) {
    this.uploadForm.fileList = fileList
  }
  topicfilechange(file) {
    this.uploadForm.fileList.push(file)
  }
  // 上传凭证
  uploadFile() {
    if (this.uploadForm.fileList.length === 0) {
      this.$message.warning('当前未选择数据')
    } else {
      let formData:any = new FormData()
      this.uploadForm.fileList.forEach((res:any) => {
        formData.append('files', res.raw)
      })
      formData.append('topicId', this.uploadForm.topicId)
      formData.append('userId', window.sessionStorage.getItem('id'))
      uploadSource(formData).then((res) => {
        if (res.code === 200) {
          this.$message.success('专家表上传成功')
          this.uploadForm.diaFile = false
          this.getFileList()
        } else if (res.code === 417) {
          this.$message.warning(res.message)
        }
      })
    }
  }
  // 删除上传的凭证
  removeFile(val) {
    let param = {
      id: val
    }
    this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      deleteUploadFile(param).then((res) => {
        if (res.code === 200) {
          this.$message.success('文件删除成功')
          this.getFileList()
        }
      })
    })
  }
  // 下载上传的凭证
  downLoadFile(val) {
    var x = new XMLHttpRequest()
    // sbdata.url字符串前面的是完整版申报pdf 后面的是论证活页的pdf
    // let href = this.baseurl + '/evaluation/' + val.filename
    let href = this.baseurl + '/evaluation/'+ val.filename
    x.open('GET', href, true)
    x.responseType = 'blob'
    x.onload = function(e) {
      var url = window.URL.createObjectURL(x.response)
      var a = document.createElement('a')
      a.href = url
      a.download = val.filename
      a.click()
    }
    x.send()
  }
  // andy 
  getYearList() {
    let d = new Date();
    let year = d.getFullYear();
    for (let index = 2021; index <= year; index++) {
      this.yearlist.unshift(index)
    }
  }
}
